import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';

interface Metadata {
  name: string;
  url: string;
}

class CopyrightComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['./style.css'];

  metadatas: Metadata[] = [];
  apiUrl = 'https://map.cartolacote.ch/background_metadata';

  constructor() {
    super('girafe-copyright');
  }

  async connectedCallback() {
    super.connectedCallback();

    await this.loadMetadata();
    this.render();
    this.girafeTranslate();
    this.renderSources();
  }

  async loadMetadata(): Promise<void> {
    try {
      const response = await fetch(this.apiUrl);
      const data = await response.json();
      this.metadatas = data.metadata ?? [];
    } catch (error) {
      console.error('Erreur chargement metadata', error);
    }
  }

  renderSources(): void {
    const container = this.shadowRoot?.querySelector('.sources');
    if (!container) return;

    container.innerHTML = '';

    this.metadatas.forEach((m, index) => {
      if (index > 0) {
        container.append(', ');
      }

      const link = document.createElement('a');
      link.href = m.url;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = m.name;

      container.appendChild(link);
    });
  }
}

export default CopyrightComponent;